import pdfMake from 'pdfmake/build/pdfmake';
import { TDocumentDefinitions } from 'pdfmake/interfaces';
import { TFunction } from 'react-i18next';

import { getFileName, saveTxtFile } from '../../../../utils/helpers/files';
import { getPdfVfs } from '../../../../utils/helpers/pdfFonts';
import { TransportEntitiesType } from '../TransportEntities.functions';

export function getDownloadButtonItems(
  t: TFunction,
  selection: TransportEntitiesType | null
) {
  const barcode = selection?.barcode ?? '';

  return [
    {
      label: 'PDF',
      icon: 'fas fa-file-pdf',
      command: () => exportToPdf(t, selection, barcode),
    },
    {
      label: t('Text'),
      icon: 'fas fa-file-alt',
      command: () => exportToFile(t, selection, barcode),
    },
  ];
}

function getQrFilename(t: TFunction, selection: TransportEntitiesType | null) {
  const fileNameIdentifiers: string[] = [
    selection?.transportEntityType?.name ?? '',
    selection?.barcode ?? '',
  ].filter(Boolean);

  return getFileName(t('Transport entities'), [
    ...fileNameIdentifiers,
    t('QR Code'),
  ]);
}

function exportToFile(
  t: TFunction,
  selection: TransportEntitiesType | null,
  barcode: string
) {
  const fileName = getQrFilename(t, selection);

  saveTxtFile(barcode, `${fileName}.txt`);
}

function exportToPdf(
  t: TFunction,
  selection: TransportEntitiesType | null,
  barcode: string
) {
  const fileName = getQrFilename(t, selection);

  const docDefinition: TDocumentDefinitions = {
    content: [
      { text: `${t('Transport entity')}:`, style: 'sectionTitle' },
      `${selection?.transportEntityType?.name ?? ''}`,
      '\n',
      { text: t('QR Code'), style: 'sectionTitle' },
      { qr: barcode, fit: 200, eccLevel: 'L', style: 'qrCode' },
    ],
    styles: {
      sectionTitle: {
        fontSize: 14,
        bold: true,
      },
      qrCode: {
        margin: [0, 7, 0, 0],
      },
    },
    pageMargins: [75, 80, 75, 80],
  };

  pdfMake
    .createPdf(docDefinition, undefined, undefined, getPdfVfs())
    .download(fileName);
}
